module.exports = "<p>\r\n  edit-flash-coupon works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/flash/flash-coupons/edit-flash-coupon/edit-flash-coupon.component.html
// module id = ./src/app/components/flash/flash-coupons/edit-flash-coupon/edit-flash-coupon.component.html
// module chunks = main